import { render } from "./ChangelogPage.vue?vue&type=template&id=6b1ba076&ts=true"
import script from "./ChangelogPage.vue?vue&type=script&lang=ts"
export * from "./ChangelogPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__